import { useEffect, useState } from 'react'

import { TGetItemFn } from '@/config/types'
import { PageName } from '@/enums/pageName'
import { getRecommendedWeight } from '@/utils/weightUtils'

type TRecommendedWeightProps = {
  getItem: TGetItemFn
}

export const RecommendedWeight = ({ getItem }: TRecommendedWeightProps) => {
  const [recommendWeight, setRecommendWeight] = useState<{
    min: string | number
    max: string | number
  }>()
  const heightData = getItem(PageName.height) || ''
  const heightDataObject = (heightData && JSON.parse(heightData)) || ''

  const weightData = getItem(PageName.weight) || ''
  const weightDataObject = (heightData && JSON.parse(weightData)) || ''

  useEffect(() => {
    const calculatedWeight = getRecommendedWeight(getItem)
    setRecommendWeight({
      min: `${calculatedWeight.min} ${calculatedWeight.unit}`,
      max: `${calculatedWeight.max} ${calculatedWeight.unit}`,
    })
  }, [getItem, heightDataObject?.quantity?.cm, heightDataObject?.type, weightDataObject.value])

  return (
    <div className="recommended-weight">
      Recommended weight range:
      <br />
      <span className="weight">
        {recommendWeight?.min} - {recommendWeight?.max}
      </span>
    </div>
  )
}
